import { render } from "./StoreDashboardProducts.vue?vue&type=template&id=3a5e676e"
import script from "./StoreDashboardProducts.vue?vue&type=script&lang=js"
export * from "./StoreDashboardProducts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/arair-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__